import React from 'react';
import purebem from 'purebem';

import type {
    FoundationTextboxTextSymbolProps,
} from './types';

import './FoundationTextboxTextSymbol.scss';


function FoundationTextboxTextSymbol({
    text,
}: FoundationTextboxTextSymbolProps): React.ReactElement {
    const block = purebem('foundation-textbox-text-symbol');
    return (
        <span className={ block() }>{ text }</span>
    );
}

export default FoundationTextboxTextSymbol;
